import { render, staticRenderFns } from "./RptDevTraTot.vue?vue&type=template&id=416d752c"
import script from "./RptDevTraTot.vue?vue&type=script&lang=js"
export * from "./RptDevTraTot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports